import { useAuth } from './use-auth';
import { ApiInstance, UserInfoParams } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';

export const useSignedUserInfo = (api: ApiInstance, params?: UserInfoParams) => {
  const { data } = useAuth();
  const uid = data?.uid;
  const { uid: uidInParams = uid } = params || {};
  return useQuery({
    enabled: !!uid,
    queryKey: ['SignedUserInfo', api, uidInParams, params],
    queryFn: async () => {
      const { data } = await api.user.getUserInfo({ ...params, uid: uidInParams });
      return data;
    },
  });
};
